import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { Message, ConfirmationService, ConfirmEventType, MessageService, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DataView } from 'primeng/dataview';
import { ActivatedRoute } from '@angular/router';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { data_fields, data_item } from 'src/app/misc/interface/data';
import { ExportService } from 'src/app/services/export.service';
import { SerializeService } from 'src/app/services/serialize.service';
import { CryptoService } from 'src/app/services/crypto.service';
import { TemplateFieldsService } from 'src/app/services/templete-fileds.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-single-data-view',
  templateUrl: './single-data-view.component.html',
  styleUrls: ['../category/search-result/search-result.component.scss', './single-data-view.component.scss']
})
export class SingleDataViewComponent {

  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");

  translator:TranslatorPipe = new TranslatorPipe()

  messages: Message[] = [];

  @ViewChild('dv')
  dataView!: DataView;

  staticURL = GlobalConstants.staticFilesURL;

  selectedfield: any;

  mainbreadcrumb: MenuItem = {
    label: "دليل الخدمات الحكومية",
    icon: "pi pi-home",
    url: "/all-data-view"
  }


  data: any[] = []

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;

  first: number = 0;
  rows: number = 10;
  sortOrder: number = 1;
  sortField: string = '';
  commentText: string = '';
  openSignModal = false


  //Accordial fields
  editIndex?: number;
  fieldTypes: any
  GlobalConstants = GlobalConstants;
  apilink = GlobalConstants.apiURL;
  editData = '';
  editPermission: boolean = false;
  deletePermission:boolean = false;
  showCommentModal: boolean = false;
  currentTypeFilter: any = 'all';
  data_types: any[] = [];
  currentService: any;
  skelition: boolean = true;
  fetchingCurrent: boolean = false;
  searchQuery: string = '';
  category_id: any = null

  filteredFields: any[] = [];
  remainingFields: any[] = [];

  currentOu: any
  currentItem: any;
  ous: OrganizationUnit[] = [];
  searchbarSearchValue: string = ''
  @Input() colors: string[] = ['#300a3b', '#2a0450', '#082f4e', '#011941', '#110d49'];

  editFlag = false

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private permissionService: PermissionHandlerService,
    private exportService: ExportService,
    private serializeService: SerializeService,
    private confirmationService: ConfirmationService,
    private cryptoService: CryptoService,
    private templateService: TemplateFieldsService,
    private render2: Renderer2
  ) { }

  ngOnInit() {
    this.fetchFieldType();
    this.route.params.subscribe(params => {

      this.searchQuery = params['id'];
      if (this.searchQuery) {
        this.fetchCurrent(this.searchQuery).then(e => {
          this.setupTypes();
          this.skelition = false;

          this.selectedfield = this.currentItem.fields.find((item: any, index: number) => {
            return index > 0 && item.data && item.data.length > 50;
          });
          
          this.currentItem.fields = this.checkField(this.currentItem.fields);
      });
      
    }
  });
  }


  getBreadcrumbs(): any[] {
    // Check if currentItem and breadcrumbs are defined
    if (this.currentItem && this.currentItem.breadcrumbs) {
      // Concatenate mainbreadcrumb with currentItem.breadcrumbs
      return [this.mainbreadcrumb, ...this.currentItem.breadcrumbs];
    }

    // Return a default value or handle the case when breadcrumbs are not available
    return [this.mainbreadcrumb];
  }


  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasUnitPermission(unit:string,flag:string) {
    return this.permissionService.hasPermission(unit,flag);
  }

  sortByDepth(items: any): any {
    console.log(items)
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return []
    }

  }


  setupTypes() {
    let mymap = new Map();

    var unique = this.data.filter((el) => {
      const item = el.type;
      if (item) {
        const val = mymap.get(item?.name);
        if (val) {
          if (item && item._id && item._id < val) {
            mymap.delete(item.name);
            mymap.set(item.name, item._id);
            return true;
          } else {
            return false;
          }
        }
        mymap.set(item.name, item._id);
        return true;
      } else {
        return false;
      }
    });

    var uniquetypes: any[] = [];
    if (unique.length > 0) {
      unique.forEach((item) => {
        uniquetypes.push(item.type);
      });
    }

    this.data_types = uniquetypes;

    console.log('data types', this.data_types);
  }

  counter(countertype: string) {
    return this.data.filter((val) => {
      if (val.type?.name == countertype) {
        return true;
      } else {
        return false;
      }
    }).length;
  }

  applyTypeFilter(value: any) {
    if (this.currentTypeFilter != value) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = 'all';
    }

    console.log(value);
    if (this.currentTypeFilter == 'all') {
      this.dataView.filter('', 'contains');
    } else {
      this.dataView.filter(value, 'equals');
    }
    this.updateTotalCount();
  }

  updateTotalCount() {
    this.totalRecords = this.dataView.totalRecords;
  }

  getFieldType(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type)?.name
  }



  reasonModal : any = false
  reasonHolder : any = undefined
  reasonError : boolean = false
  deleteFlag : boolean = false

  updateReasonModal(deleteFlag:boolean = false){
    if (
      !this.currentItem.fields.some((field: any) => field.isChecked === true) &&
      this.currentItem.name == this.previousView.name  && deleteFlag == false
    ) {
      return;
    }
    this.reasonModal = true
    this.reasonHolder = ''

    if(deleteFlag){
      this.deleteFlag = true
    }

  }

  updateData() {

    this.reasonError = false    

    if(!this.reasonHolder || this.reasonHolder == '') {
      this.reasonError = true
      return
    }

    // for delete
    if(this.deleteFlag){
      this.deleteService()
      return
    }

     // if no filed is checked
     if (
      !this.currentItem.fields.some((field: any) => field.isChecked === true) &&
      this.currentItem.name == this.previousView.name
    ) {
      return;
    }

    // console.log("Flaten array",flatenArrayofFileds, flatenFields);

    let updateLog = {
      status: 'PENDING',
      type: 'EDIT',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview: this.previousView
      },
      after: {
        name: this.currentItem.name,
        fields: this.currentItem.fields

      },
      ous: this.currentItem.ous,
      service_id: this.currentItem._id,
      reason : this.reasonHolder
    }

    this.editContent(updateLog).then(() => {
      //set all checks to false
      const updatedFields = this.currentItem.fields.map((field: any) => ({ ...field, isChecked: false }));
      this.currentItem.fields = updatedFields;
      window.location.reload()
    })



  }


  // updateData(field: any) {
  //   let updateLog = {
  //     status: 'PENDING',
  //     type: 'EDIT',
  //     before: {
  //       'field.type': field.field[0]._id,
  //       data: field.data
  //     },
  //     after: {
  //       'field.type': field.field[0]._id,
  //       data: this.editData
  //     },
  //     ous: this.currentOu.ous,
  //     service_id: this.currentItem._id
  //   }
  //   this.editContent(updateLog)
  // }


  async editContent(data: any) {
    try {

      let res = await this.dataService.postData('content-update/', data)

      if (res.error) {
        return
      }
      let isOuPermission: boolean = await this.permissionService.checkOUPermissionByID('CONTENT_UPDATE_LOGS', 'r', data.ous)
      if (this.permissionService.hasPermission('CONTENT_APPROVE', 'a') && isOuPermission) {

        //Approving log
        data._id = res.data._id
        data.status = 'APPROVED'
        let res2 = await this.dataService.postData('content-update/approve', data, 'PUT', false);
        if (res2.error) {
          this.messages = [
            { severity: 'error',  summary: this.translate('error'), detail: res.msg },
          ];
          return
        }
      }

      window.location.reload()
    } catch (error) {
      console.log(error)
    }
  }

  async checkEditPermission() {
    if (this.currentOu._id != null && this.currentItem._id != undefined) {
      this.editPermission = await this.permissionService.checkOUPermissionByID(
        'CONTENT',
        'u',
        this.currentOu._id
      );
      this.deletePermission = await this.permissionService.checkOUPermissionByID(
        'CONTENT',
        'd',
        this.currentOu._id
      );
    } else {
      this.editPermission = await this.permissionService.checkOUPermission(
        'CONTENT',
        'u',
        this.currentOu.label
      );
      this.deletePermission = await this.permissionService.checkOUPermission(
        'CONTENT',
        'd',
        this.currentOu.label
      );
    }
  }

  hasPermission(unit:string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data
  }

  handleSearchbarValueChange(val: string) {
    this.searchbarSearchValue = val;
  }

  editDataSave(arg0: string[] | string | undefined) {
    if (arg0) {
      if (Array.isArray(arg0)) {
        var editData = '';
        arg0.forEach((ele) => {
          editData = editData + ' <br> ' + ele;
        });
        this.editData = editData.slice(5);
      } else {
        this.editData = arg0;
      }
    }
  }

  async deleteService() {
    let deleteLog = {
      status: 'PENDING',
      type: 'DELETE',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview: this.previousView
      },
      ous: this.currentItem.ous,
      service_id: this.currentItem._id,
      reason : this.reasonHolder
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.editContent(deleteLog)
    });

  }


  async makeComment() {
    if (!this.commentText || this.commentText == '') {
      return;
    }
    try {
      let data = {
        data_id: this.currentItem._id,
        ou: this.currentOu?._id,
        like: true,
        text: this.commentText
      }
      let res = await this.dataService.postData('comments/', data);
      this.showCommentModal = false
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.commentText = '';
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
    } catch (error) {
      console.log(error);
    }
  }

  previousView: any

  async changeCurrent(current: any) {
    if (this.currentService?._id != current?._id) {
      this.currentService = current;
      if (this.currentService) {
        this.fetchingCurrent = true;
        this.currentItem = await this.getOne();
        
        this.fetchingCurrent = false;
      }

      if (this.currentItem) {
        this.currentItem.fields?.sort((a: data_fields, b: data_fields) => {
          if (a.label?.priority && b.label?.priority) {
            return a.label?.priority - b.label?.priority;
          } else {
            return 0;
          }
        });

        this.currentItem.breadcrumbs.sort((a: any, b: any) => {
          return b.depth - a.depth;
        });


        //new changes
        //creating deep copy of old old object
        this.previousView = { ...this.currentItem }

        //adding check
        this.currentItem = {
          ...this.currentItem,
          fields: this.currentItem?.fields?.map((item: any) => {
            return { ...item, isChecked: false };
          }) || []
        };

        this.currentItem.fields = await this.templateService.fetchTemplateFields(this.currentItem);

        if (this.currentOu) {
          if (this.currentOu._id != current.ou) {
            this.currentOu = this.currentItem.parent;
            this.checkEditPermission();
          }
        } else {
          this.currentOu = this.currentItem.parent;
          this.checkEditPermission();
        }
      }
    }
  }

  async fetchCurrent(id: string) {
        this.fetchingCurrent = true;
        this.currentItem = await this.getOneById(id);
        this.fetchingCurrent = false;

      if (this.currentItem) {
        this.currentItem.fields?.sort((a: data_fields, b: data_fields) => {
          if (a.label?.priority && b.label?.priority) {
            return a.label?.priority - b.label?.priority;
          } else {
            return 0;
          }
        });

        this.currentItem.breadcrumbs.sort((a: any, b: any) => {
          return b.depth - a.depth;
        });


        //new changes
        //creating deep copy of old old object
        this.previousView = { ...this.currentItem }

        //adding check
        this.currentItem = {
          ...this.currentItem,
          fields: this.currentItem?.fields?.map((item: any) => {
            return { ...item, isChecked: false };
          }) || []
        };

        this.currentItem.fields = await this.templateService.fetchTemplateFields(this.currentItem);

        console.log("this.currentItem.fields", this.currentItem.fields)

        // Filter the items and separate into two arrays
        this.currentItem.fields.forEach((field: any, i:number) => {

          if(field.data.fields) {
            field.data.fields?.sort((a: data_fields, b: data_fields) => {
              if (a.label?.priority && b.label?.priority) {
                return a.label?.priority - b.label?.priority;
              } else {
                return 0;
              }
            });
          }

          if(i!=0 || field.data.type) {
            if (field.data.length < 100 && this.filteredFields.length < 3) {
              // Add to filteredFields if condition is met and limit not reached
              this.filteredFields.push(field);
            } else {
              // Add to remainingFields if condition is not met or limit is reached
              this.remainingFields.push(field);
            }
          }
        });

          console.log("this.remainingFields[0];", this.remainingFields, this.filteredFields)
          this.selectedfield = this.remainingFields[0];

          this.currentOu = this.currentItem.parent;
          this.checkEditPermission();
      }
  }

  async searchData(keywork: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData('data/textSearch?text=' + keywork);
      if (res.error) {
        return
      }
      this.data = res.data;

      if (this.data.length > 0) {
        // this.data.sort((a, b) => {
        //   if (a.id > b.id) {
        //     return 1;
        //   } else if (a.id < b.id) {
        //     return -1;
        //   }
        //   return 0;
        // })
        this.changeCurrent(this.data[0])
      }
      this.totalRecords = this.data.length
      this.first = 0;
      this.rows = 10;
    } catch (error) {
      console.log(error)
    }
  }

  async getOne() {
    try {
      let res = await this.dataService.getData('data/one/' + this.currentService.id);
      if (res.error) {
        return
      }
      return res.data[0];
    } catch (e) {
      console.log(e);
    }
  }

  async getOneById( id: string) {
    try {
      let res = await this.dataService.getData('data/one/' + id);
      if (res.error) {
        return
      }
      return res.data[0];
    } catch (e) {
      console.log(e);
    }
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    console.log(maxPage, this.currentPage, this.currentPage >= 1 && this.currentPage <= maxPage);
    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ first: this.first, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        first: this.first,
        rows: this.rows
      });
    }
  }

  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      console.log(n, this.currentPage, maxPage);
      this.currentPage = n;
      this.goToPage(n);
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dataView.filter($event.target.value, stringVal);
  }

  changeView(_t29: any) {
    this.changeCurrent(_t29);
    this.createStates(_t29)
  }



  async createStates(data: any) {
    try {
      let uid = localStorage.getItem('uid');
      let user_name = localStorage.getItem('username')
      let payload = {
        user: {
          _id: uid,
          name: user_name
        },
        service_id: data._id,
        keyword: this.searchQuery,
        category_id: data.id
      }
      let res = await this.dataService.postData('states', payload)
      if (res.error) {
        console.warn("states log not created ...")
      }
    } catch (error) {
      console.log(error)
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  sortFiled(fileds: any): Array<any> {
    return fileds?.sort((a: any, b: any) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });
  }


  copyLinkToClipboard() {
    this.serializeService.copyToClipboard(location.href);
    this.messages = [
      { severity: 'success', summary: this.translate('Link copied to clipboard'), detail: "Link copied to clipboard", life: 10000 },
    ]
  }


  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }

  checkField(arg0: any): any {

    console.log("check field", arg0)

    if(this.getFieldType(arg0[0]?.label?.type) == 'Data Item') {

      arg0.unshift({
        "label": {
            "name": "وصف الخدمة",
            "icon": "fa-solid fa-signature",
            "active": true,
            "priority": 0
        },
        "type": {
            "name": "Rich text",
            "arabic": "حقل نصي متقدم",
            "active": true,
        },
        "data": "",
        "_id": "65b57e3e2bc830474a0159a6",
        "field": {
            "_id": "656ec16aba096706e35daf75",
            "name": "وصف الخدمة",
            "type": "6464dac9f6932edf1f72fe35",
            "icon": "fa-solid fa-signature",
            "active": true,
            "createdAt": "2023-12-05T06:21:30.821Z",
            "updatedAt": "2023-12-05T08:12:17.798Z",
            "__v": 0,
            "priority": 1
        },
        "isChecked": false
    })

    console.log("arg0===>", arg0)

    }

    return arg0;

    
  }

  async updateFavourite() {
    try {
      let data = this.currentItem.id;
      let res = await this.dataService.postData('data/update-favorite/' + data, {});
      if (res.error) return;
      let favorites = JSON.parse(localStorage.getItem('favoriteData') || '[]');
      const index = favorites.indexOf(data);
      if (index === -1){
         favorites.push(data);
        }
      else {
        favorites.splice(index, 1);
      }
      localStorage.setItem('favoriteData', JSON.stringify(favorites));
      console.log(res.msg);
    } catch (error) {
      console.log(error);
    }
  }

  isFavorite(id: number = this.currentItem.id): boolean {
    let favorites = JSON.parse(localStorage.getItem('favoriteData') || '[]');
    return favorites.includes(id);
  }

  changeModal(flag:boolean){
    
    this.openSignModal = flag
  }

  hasEditPermissionWithType(): boolean {
    const allowedTypes = this.permissionService.extractTags('CONTENT_UPDATE_DATA_TYPE', 'r');
    return allowedTypes.includes(this.currentItem.type._id);
  }


}